import { useTranslation } from 'react-i18next'
import isEmpty from 'lodash-es/isEmpty'

import { createContract } from '../../../api'
import { useInlineNotifications, useNotification } from '../../../hooks'
import { parseServerValidation } from '../../../utils/validation'
import { FormikForm } from '../../Formik'

import {
  getContractCreatedNotification,
  getContractCreationErrorNotification,
  getContractFormPayload,
  getContractValidationSchema,
} from './ContractForm.utils'
import { FormFields } from './FormFields'

function ContractForm({
  FormContainer,
  containerProps,
  getErrorNotification = getContractCreationErrorNotification,
  getPayload = getContractFormPayload,
  getSuccessNotification = getContractCreatedNotification,
  initialValues,
  submitApi = createContract,
  onCancel,
  onClose,
  onEntityReload,
  onReloadList,
  ...restProps
}) {
  const { t } = useTranslation()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications()

  function handleSuccess() {
    onClose?.()
    handleAddSuccessNotification(getSuccessNotification(t))
    onReloadList?.()
    onEntityReload?.()
  }

  function handleError() {
    handleAddErrorNotification(getErrorNotification(t))
  }

  function handleSubmit(values, { setErrors, setSubmitting }) {
    submitApi({ data: getPayload(values) })
      .then(handleSuccess)
      .catch(({ response }) => {
        setSubmitting(false)

        if (isEmpty(response?.data)) {
          handleError()
        } else {
          setErrors(parseServerValidation(response?.data))
        }
      })
  }

  return (
    <FormikForm
      enableReinitialize
      Container={FormContainer}
      containerProps={containerProps}
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={getContractValidationSchema(t)}
      onSubmit={handleSubmit}
    >
      <FormFields
        {...restProps}
        notifications={notifications}
        onCancel={onCancel}
        onRemoveNotification={handleRemoveNotification}
        onSetNotification={handleAddNotification}
      />
    </FormikForm>
  )
}

export default ContractForm
